export const vpkClassroomQuestion = {
    requiredQualification: '45 Hours Completed',
    prompt: 'Will the substitute be working in a VPK classroom?',
    businessFlag: 'has_vpk_location',
} as const;

export const vpkClassroomHelperText = `If yes, we'll automatically add ${vpkClassroomQuestion.requiredQualification} to the required credentials.`;
